import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useUSAJILIColorMode } from '@theme/USAJILIThemeProvider';

/** Current time, refreshed every `ms` milliseconds. */
export function useNow(ms = 30_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), ms);
    return () => window.clearInterval(id);
  }, [ms]);
  return now;
}

export const HEADER_RED = { dark: '#FF5A5A', light: '#C62828' } as const;

interface Props {
  dataFrom?: string | null;
  dataTo?: string | null;
  countyCount?: number;
}

/** Header sub-line: data range · counties · today's date and time, in bold red. */
export const USAJILIHeaderStatus: React.FC<Props> = ({ dataFrom, dataTo, countyCount }) => {
  const { mode } = useUSAJILIColorMode();
  const now = useNow();

  const range =
    dataFrom && dataTo
      ? `${dayjs(dataFrom).format('D MMM')} – ${dayjs(dataTo).format('D MMM YYYY')}`
      : null;
  const parts = [
    range,
    countyCount ? `${countyCount} counties` : null,
    dayjs(now).format('ddd D MMM YYYY, HH:mm'),
  ].filter(Boolean);

  return (
    <Box>
      <Typography component="span" sx={{ fontSize: { xs: '0.8rem', sm: '0.95rem', md: '1.05rem' }, fontWeight: 700, color: HEADER_RED[mode] }}>
        {parts.join(' · ')}
      </Typography>
    </Box>
  );
};
